import { useEffect, useState } from "react";

export const usePersistentState = (storageKey, defaultValue) => {
  const [value, setValue] = useState(() => {
    if (typeof window === "undefined") {
      return defaultValue;
    }

    try {
      const raw = window.localStorage.getItem(storageKey);
      return raw !== null ? JSON.parse(raw) : defaultValue;
    } catch (error) {
      return defaultValue;
    }
  });

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    try {
      window.localStorage.setItem(storageKey, JSON.stringify(value));
    } catch (error) {
      // Ignore localStorage write failures (private mode/quota).
    }
  }, [storageKey, value]);

  return [value, setValue];
};

